module.exports = __webpack_public_path__ + "img/proxima-positive-without-symptons.5de2748f.png";